import React from "react";
import "./form-input.styles.css";

const TYPE_CLASSES = {
  signIn: "sign-in",
  prayer: "prayer",
  guestDisplayName: "guest-display-name",
  guestEmail: "guest-email",
};

const FormInput = ({ label, inputType, ...otherProps }) => {
  return (
    <div>
      <label className={`label-${TYPE_CLASSES[inputType]}`}>{label}</label>
      <input className={`input-${TYPE_CLASSES[inputType]}`} {...otherProps} />
    </div>
  );
};

export default FormInput;
